import { onMounted, ref, getCurrentInstance } from 'vue'

export default function () {
  const itemList = ref([])

  const { proxy } = getCurrentInstance()

  async function getItemList() {
    const res = await proxy.$http({
      type: 'get',
      url: '/Item/getItemLists',
      params: {
        page: 1,
        limit: 1000,
      },
    })
    if (res.code == 0) {
      itemList.value = [{ id: 0, title: '无赠送' }, ...res.data.data]
    }
  }

  onMounted(() => {
    getItemList()
  })

  function getItemName(id) {
    const temp = itemList.value.find((item) => id == item.id)
    if (temp) {
      return temp.title
    } else {
      return ''
    }
  }

  return { itemList, getItemName }
}
